import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';

//import images
import avatar1 from '../../../assets/images/users/user-pic.jpg';
import { useProfile } from '../../../components/Hooks/UserHooks';
import { PageWrapper } from '../../../components/pageWrapper';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { UpdateUsers, Users } from '../../../store/users/action';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

// utils
import { APIClient } from '../../../helpers/api_helper';
import { useLoading } from '../../../hook/useLoading';
import { notifyError, notifySuccess } from '../../../components/notify';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [image, setImage] = useState('');
  const [user, setUser] = useState({});

  const api = new APIClient();
  const history = useHistory();
  const dispatch = useDispatch();
  const { userProfile } = useProfile();
  const { toggleLoading, setLoading, loadingWithTime } = useLoading();

  const { users } = useSelector((state) => ({
    users: state.Users.users,
  }));

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = e.target;

    let form = {
      id: user.id,
      password: currentPassword.value,
      new_password: newPassword.value,
      confirm_password: confirmPassword.value,
    };

    toggleLoading();
    api
      .create('/register/user/change-password', form)
      .then((response) => {
        notifySuccess(response.message);
      })
      .catch((error) => {
        notifyError(error.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: user ? user.name : '',
      usernameInput: user ? user.username : '',
      emailInput: user ? user.email : '',
      // passwordInput: '',
    },
    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      usernameInput: Yup.string().required('Usuário é obrigatório'),
      emailInput: Yup.string().required('Digite um email válido'),
      // passwordInput: userProfile
      //   ? Yup.string()
      //   : Yup.string().required('Digite uma senha'),
    }),
    onSubmit: (values) => {
      const valuesToSubmit = {
        ...user,
        name: values.nameInput || null,
        username: values.usernameInput || null,
        email: values.emailInput || null,
        photo: image || null,
        // password: values.passwordInput || null,
      };

      loadingWithTime(1000);
      dispatch(UpdateUsers({ id: user.id, data: valuesToSubmit }));
    },
  });

  const findUser = (username) => {
    const user = (users || []).find((usr) => usr.username === username);

    if (user) {
      setUser(user);
    }
  };

  useEffect(() => {
    dispatch(Users());
  }, [dispatch]);

  useEffect(() => {
    findUser(userProfile.data.username);
  }, [users]);

  return (
    <PageWrapper title={'Perfil'}>
      {/*<div className="position-relative mx-n4 mt-n4">*/}
      {/*  <div className="profile-wid-bg profile-setting-img">*/}
      {/*    <img src={progileBg} className="profile-wid-img" alt="" />*/}
      {/*    <div className="overlay-content">*/}
      {/*      <div className="text-end p-3">*/}
      {/*        <div className="p-0 ms-auto rounded-circle profile-photo-edit">*/}
      {/*          <Input*/}
      {/*            id="profile-foreground-img-file-input"*/}
      {/*            type="file"*/}
      {/*            className="profile-foreground-img-file-input"*/}
      {/*          />*/}
      {/*          <Label*/}
      {/*            htmlFor="profile-foreground-img-file-input"*/}
      {/*            className="profile-photo-edit btn btn-light"*/}
      {/*          >*/}
      {/*            <i className="ri-image-edit-line align-bottom me-1"></i>{' '}*/}
      {/*            Change Cover*/}
      {/*          </Label>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      <Row>
        <Col xxl={8} md={8} sm={12}>
          <Card>
            <CardHeader>
              <Nav
                className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                role="tablist"
              >
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => {
                      tabChange('1');
                    }}
                  >
                    <i className="fas fa-home"></i>
                    Detalhes pessoais
                  </NavLink>
                </NavItem>
              </Nav>
            </CardHeader>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Form
                  autoComplete="off"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <CardBody className="p-4">
                    <Row>
                      <Col md={3}>
                        <div className="text-center">
                          <h5 className="fs-16 mb-3">
                            {userProfile?.data.first_name}
                          </h5>
                          <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                            <img
                              src={user.photo || image || avatar1}
                              className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                              alt="user-profile"
                            />
                            <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                              <Input
                                id="profile-img-file-input"
                                type="file"
                                className="profile-img-file-input"
                                onChange={(e) => {
                                  if (
                                    e.target.files[0].type === 'image/jpeg' ||
                                    e.target.files[0].type === 'image/png'
                                  ) {
                                    getBase64(e.target.files[0]).then(
                                      (data) => {
                                        setImage(data);
                                      }
                                    );
                                  } else {
                                    alert('Formato inválido');
                                  }
                                }}
                              />
                              <Label
                                htmlFor="profile-img-file-input"
                                className="profile-photo-edit avatar-xs"
                              >
                                <span className="avatar-title rounded-circle bg-light text-body">
                                  <i className="ri-camera-fill"></i>
                                </span>
                              </Label>
                            </div>
                          </div>
                        </div>
                      </Col>

                      {/* <Col md={12}>
                            <div className="mb-3">
                              <Label htmlFor="name" className="form-label">
                                Usuário
                              </Label>
                              <Input
                                disabled
                                type="text"
                                className="form-control"
                                id="usernameInput"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.usernameInput || ''}
                              />
                              {validation.touched.usernameInput &&
                              validation.errors.usernameInput ? (
                                <p className="labelErrorValidation">
                                  {validation.errors.usernameInput}
                                </p>
                              ) : null}
                            </div>
                          </Col> */}

                      <Col md={12}>
                        <div className="mb-3">
                          <Label htmlFor="name" className="form-label">
                            Nome
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="nameInput"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.nameInput || ''}
                          />
                          {validation.touched.nameInput &&
                          validation.errors.nameInput ? (
                            <p className="labelErrorValidation">
                              {validation.errors.nameInput}
                            </p>
                          ) : null}
                        </div>
                      </Col>

                      <Col md={12} sm={12}>
                        <div className="mb-3">
                          <Label htmlFor="emailInput" className="form-label">
                            Email
                          </Label>
                          <Input
                            type="email"
                            className="form-control"
                            id="emailInput"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.emailInput || ''}
                          />
                          {validation.touched.emailInput &&
                          validation.errors.emailInput ? (
                            <p className="labelErrorValidation">
                              {validation.errors.emailInput}
                            </p>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <Col md={12}>
                      <div className="text-end d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-link"
                          style={{
                            marginRight: '10px',
                          }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          Cancelar
                        </button>
                        <button type="submit" className="btn btn-primary">
                          Salvar
                        </button>
                      </div>
                    </Col>
                  </CardFooter>
                </Form>
              </TabPane>
            </TabContent>
          </Card>
        </Col>

        <Col xxl={4} md={4} sm={12}>
          <Card>
            <CardBody className="p-4">
              <h5 className="fs-16 mb-3">Alterar senha</h5>
              <Form
                autoComplete="off"
                onSubmit={(e) => {
                  handleChangePassword(e);
                }}
              >
                <Col md={12} sm={12}>
                  <div className="mb-3">
                    <Label htmlFor="currentPassword" className="form-label">
                      Senha atual
                    </Label>
                    <Input
                      id="currentPassword"
                      type="password"
                      className="form-control"
                    />
                  </div>
                </Col>

                <Col md={12} sm={12}>
                  <div className="mb-3">
                    <Label htmlFor="newPassword" className="form-label">
                      Nova senha
                    </Label>
                    <Input
                      id="newPassword"
                      type="password"
                      className="form-control"
                    />
                  </div>
                </Col>

                <Col md={12} sm={12}>
                  <div className="mb-3">
                    <Label htmlFor="confirmPassword" className="form-label">
                      Repetir nova senha
                    </Label>
                    <Input
                      id="confirmPassword"
                      type="password"
                      className="form-control"
                    />
                  </div>
                </Col>

                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button type="submit" className="btn btn-primary">
                      Alterar
                    </button>
                  </div>
                </Col>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};

export default Settings;
